import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import classes from "./ConfirmDialog.module.scss"
import { ConfirmDialogProps } from "../../interfaces/props/ConfirmDialogProps";
import { useMemo } from "react";
import { Statuses } from "../../enums/Statuses";

const ConfirmDialog = ({ open, onClose, onConfirm, title, message, status }: ConfirmDialogProps) => {
  const confirmButton = useMemo(() => {
    if (status === Statuses.PENDING) {
      return <Button onClick={onConfirm} disabled className={`${classes['confirm-button']}`}>Confirming</Button>
    }

    if (status === Statuses.SUCCESS) {
      return <Button onClick={onConfirm} disabled className={`${classes['confirm-button']}`}>Confirmed</Button>
    }

    return <Button onClick={onConfirm} className={`${classes['confirm-button']}`}>Confirm</Button>
  }, [status, onConfirm]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle className='h2' >{title}</DialogTitle>
      <DialogContent>
        <DialogContentText className={classes['content-text']} >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={'d-flex justify-content-end gap-4 m-1'}>
        <Button className={classes['cancel-button']} onClick={onClose}>
          Cancel
        </Button>
        {confirmButton}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
